import { Filter } from "../../components";
import { formatEntityName } from "./entityName";

export interface Option {
  label: string;
  value: string;
  displayValue?: string;
}

export const mediaDurationValueMapping = {
  "<= 1 min": {
    lte: 60,
  },
  "1-3 mins": {
    gte: 60,
    lte: 180,
  },
  "3-5 mins": {
    gte: 180,
    lte: 300,
  },
  "5-9 mins": {
    gte: 300,
    lte: 540,
  },
  "9+ mins": {
    gte: 540,
  },
};

export interface ObjectValue {
  gte?: number;
  lte?: number;
}

export const FetchFilters = (
  orgBusTeamConstants: [],

  categoriesConst?: Record<string, Option[]>,
  languageConst?: Option[],
  users?: any,
  singleCurrentUser?: any,
  bunchProductList?: any,
  agencies?: any,
  bunchBusinessList?: any,
  type?: string,
  requiredFilters?: string[]
): Filter[] => {
  const categoriesConstOptionArray = Object?.entries(
    categoriesConst || {}
  )?.flatMap(([categoryName, options]) => {
    if (options?.length === 0) {
      return [
        {
          label: categoryName,
          value: categoryName,
          displayValue: categoryName,
        },
      ];
    }

    return options?.map((option) => ({
      label: `${categoryName} - ${option.value}`,
      value: `${categoryName} - ${option.value}`,
      displayValue: `${categoryName} - ${option.value}`,
    }));
  });

  const businessConstOptionArray: Option[] = bunchBusinessList?.map(
    (values: any) => {
      return {
        label: formatEntityName(values),
        value: values?.id,
        displayValue: formatEntityName(values),
        baseURL: values?.baseurl,
        logo: values?.logo,
      };
    }
  );

  const teamListOptionArray: Option[] = bunchProductList?.map(
    (values: any) => ({
      label: formatEntityName(values),
      value: values?.id,
      displayValue: formatEntityName(values),
      baseURL: values?.baseurl,
      logo: values?.logo,
    })
  );

  const teamConstOptionArray: Option[] = bunchProductList?.map((value: any) => {
    return {
      label: formatEntityName(value),
      value: value?.id,
      displayValue: formatEntityName(value),
    };
  });

  const userConstOptionArray: Option[] = users?.map((value: any) => {
    return {
      label: value.name,
      value: value.id,
      displayValue: value.name,
    };
  });

  const teamFilterArray: Filter[] = [
    {
      displayName: "Name",
      name: "id",
      type: "multiselect",
      suffix: "Contains",
      options: teamListOptionArray,
    },
    {
      displayName: "Status",
      name: "status",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Active", value: "1", displayValue: "Active" },
        { label: "Inactive", value: "2", displayValue: "Inactive" },
      ],
    },
    {
      displayName: "Business",
      name: "business",
      type: "multiselect",
      suffix: ":",
      options: businessConstOptionArray,
    },
  ];
  const filterArray: Filter[] = [
    {
      displayName: "Media ID",
      name: "id",
      type: "text",
      suffix: "Contains",
    },
    {
      displayName: "Title & description",
      name: "title",
      type: "text",
      suffix: "Contains",
    },
    {
      displayName: "Status",
      name: "status",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Processing", value: "4", displayValue: "Processing" },
        { label: "Ready", value: "5", displayValue: "Ready" },
        { label: "Created", value: "1", displayValue: "Created" },
      ],
    },
    {
      displayName: "Language",
      name: "lang",
      type: "multiselect",
      suffix: ":",
      options: languageConst,
    },
    {
      displayName: "Content Category",
      name: "category",
      type: "multiselect",
      suffix: ":",
      options: categoriesConstOptionArray,
    },
    {
      displayName: "Content Source",
      name: "source",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Chopper", value: "chopper", displayValue: "Chopper" },
      ],
    },
    {
      displayName: "Producer",
      name: "producer",
      type: "text",
      suffix: "Contains",
    },
    {
      displayName: "Asset Type",
      name: "type",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Video", value: "video", displayValue: "Video" },
        { label: "Audio", value: "audio", displayValue: "Audio" },
      ],
    },
    {
      displayName: "Business",
      name: "business",
      type: "multiselect",
      suffix: ":",
      options: businessConstOptionArray,
    },
    {
      displayName: "Team/Property",
      name: "team",
      type: "multiselect",
      suffix: ":",
      options: teamConstOptionArray,
    },
    {
      displayName: "Content Used",
      name: "content_used",
      type: "radio",
      suffix: ":",
      options: teamConstOptionArray,
    },

    {
      displayName: "Agency",
      name: "agency",
      type: "autoselect",
      suffix: ":",
      options: [], // Empty static options - will use dynamic options from autoSelectOptionsMap
    },
    {
      displayName: "Content Type",
      name: "ctype",
      type: "multiselect",
      suffix: ":",
      options: [
        { label: "Interview", value: "interview", displayValue: "Interview" },
        {
          label: "Explainers",
          value: "explainers",
          displayValue: "Explainers",
        },
        {
          label: "Package Story",
          value: "package Story",
          displayValue: "Package Story",
        },
        { label: "Bytes", value: "bytes", displayValue: "Bytes" },
        { label: "VoxPop", value: "voxPop", displayValue: "VoxPop" },
        { label: "Live", value: "live", displayValue: "Live" },
        { label: "Podcast", value: "podcast", displayValue: "Podcast" },
        { label: "Music", value: "music", displayValue: "Music" },
        {
          label: "Advertorial",
          value: "advertorial",
          displayValue: "Advertorial",
        },
        { label: "Campaign", value: "campaign", displayValue: "Campaign" },
      ],
    },
    {
      displayName: "Content Status",
      name: "media_status",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Draft", value: "0", displayValue: "Draft" },
        { label: "Activating", value: "1", displayValue: "Activating" },
        { label: "Active", value: "2", displayValue: "Active" },
        { label: "Inactive", value: "3", displayValue: "Inactive" },
        { label: "Deleted", value: "-2", displayValue: "Deleted" },
        { label: "Error", value: "-3", displayValue: "Error" },
      ],
    },

    {
      displayName: "Uploader",
      name: "ctby",
      type: "autoselect",
      suffix: ":",
      options: [
        { label: "Me", value: singleCurrentUser?.id, displayValue: "Me" },
        ...userConstOptionArray,
      ],
    },
    {
      displayName: "Published Destinations",
      name: "publishing_destinations",
      type: "multiselect",
      suffix: ":",
      options: [
        { label: "Denmark", value: "denmark", displayValue: "Denmark" },
        { label: "YouTube", value: "youtube", displayValue: "YouTube" },
        { label: "Facebook", value: "facebook", displayValue: "Facebook" },
        { label: "Instagram", value: "instagram", displayValue: "Instagram" },
        { label: "X", value: "twitter", displayValue: "X" },
        { label: "Linkedin", value: "linkedin", displayValue: "Linkedin" },
      ],
    },
    {
      displayName: "Media Duration",
      name: "media_duration",
      type: "radio",
      suffix: ":",
      options: [
        // { label: 'All', value: 'All', displayValue: 'All' },
        { label: "<= 1 min", value: "<= 1 min", displayValue: "<= 1 min" },
        { label: "1-3 mins", value: "1-3 mins", displayValue: "1-3 mins " },
        { label: "3-5 mins", value: "3-5 mins", displayValue: "3-5 mins" },
        { label: "5-9 mins", value: "5-9 mins", displayValue: "5-9 mins" },
        { label: "9+ mins", value: "9+ mins", displayValue: "9+ mins" },
      ],
    },
    {
      displayName: "Upload Date",
      name: "range",
      type: "date",
      suffix: ":",
    },
    {
      displayName: "Modified Date",
      name: "rangeMD",
      type: "date",
      suffix: ":",
    },
    {
      displayName: "Tags",
      name: "tags",
      type: "tags",
      suffix: "",
    },

    {
      displayName: "Views",
      name: "views",
      type: "views",
      suffix: "",
    },
    {
      displayName: "Relationship Type",
      name: "media_ref",
      type: "radio",
      suffix: ":",
      options: [
        { label: "Trimmed", value: "trimmed", displayValue: "Trimmed" },
        { label: "Embed", value: "embed", displayValue: "Embed" },
        { label: "Simulive", value: "simulive", displayValue: "Simulive" },
        { label: "Clone", value: "clone", displayValue: "Clone" },
        { label: "Podcast", value: "podcast", displayValue: "Podcast" },
        { label: "Slate", value: "slates", displayValue: "Slate" },
        { label: "Campaign", value: "campaign", displayValue: "Campaign" },
        // { label: "Premiere", value: "premiere", displayValue: "Premiere" },
      ],
    },
    {
      displayName: "Modifier",
      name: "mtbyuser",
      type: "autoselect",
      suffix: ":",
      options: [
        { label: "Me", value: singleCurrentUser?.id, displayValue: "Me" },
        ...userConstOptionArray,
      ],
    },
    {
      displayName: "Agency Group",
      name: "agencies",
      type: "radio",
      suffix: ":",
      options: [
        { label: "In-House", value: "1", displayValue: "In-House" },
        { label: "Wired", value: "2", displayValue: "Wire" },
        { label: "Stringers", value: "3", displayValue: "Stringers" },
        { label: "Group Company", value: "4", displayValue: "Group Company" },
      ],
    },
  ];

  // Filter based on requiredFilters if provided
  // const filterByRequired = (filters: Filter[]) => {
  //   if (!requiredFilters || requiredFilters.length === 0) {
  //     return filters;
  //   }

  //   return filters.filter((filter) => requiredFilters.includes(filter.displayName));
  // };

  const filterByRequired = (filters: Filter[]) => {
    if (!requiredFilters || requiredFilters.length === 0) {
      return filters;
    }

    // Create a map for quick lookup
    const filterMap = new Map(
      filters.map((filter) => [filter.displayName, filter])
    );

    // Return filters in the order specified by requiredFilters
    return requiredFilters
      .map((filterName) => filterMap.get(filterName))
      .filter(Boolean) as Filter[];
  };

  if (type === "team") return filterByRequired(teamFilterArray);
  return filterByRequired(filterArray);
};
